import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  Brand,
  BrandsModelsRequest,
  BrandsRequest,
  Model,
  ModelsRequest,
} from './BrandsModelsVersions.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}`;

export async function listBrandsFilter(
  params: BrandsRequest,
): Promise<PageResult<Brand>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/brands/filter`,
    params,
  )) as unknown;

  return result as PageResult<Brand>;
}

export async function getBrand(id: number): Promise<Brand> {
  const result = (await api.get(
    `${CONTROLLER_URL}/brands/${id}`,
    null,
  )) as unknown;

  return result as Brand;
}

export async function listModelsFilter(
  params: ModelsRequest,
): Promise<PageResult<Model>> {
  const { brandId, ...filter } = params;
  const result = (await api.get(
    `${CONTROLLER_URL}/brands/${brandId}/models/filter`,
    filter,
  )) as unknown;

  return result as PageResult<Model>;
}

export async function getModel(id: number): Promise<Model> {
  const result = (await api.get(
    `${CONTROLLER_URL}/models/${id}`,
    null,
  )) as unknown;

  return result as Model;
}

export async function listBrandsModels(
  params?: BrandsModelsRequest,
): Promise<PageResult<Model>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/brands-models`,
    params,
  )) as unknown;

  return result as PageResult<Model>;
}
